export default __webpack_public_path__ + "static/media/Pachmarhi.febc1165.jpg";